import { z } from 'zod';

/**
 * One allowlisted SMA field that can be copied from the warehouse member feed.
 */
export interface StandardMemberAttributeBackfillColumnDto {
  camelCase: string;
  snakeCase: string;
  sqlType: 'varchar' | 'boolean';
}

/**
 * Body for `POST …/member-standard-attributes/backfill-column`.
 *
 * Omitting `commit` (or any value other than `true`) is a dry run. SMA is
 * written only when `commit: true`. `warehouseBatchLimit` is dry-run only.
 */
export const StandardMemberAttributeColumnBackfillRequestSchema = z
  .object({
    column: z.string().min(1),
    commit: z.boolean().optional(),
    warehouseBatchLimit: z.number().int().positive().max(10000).optional(),
  })
  .strict();

/** Parsed operator request for an SMA column backfill. */
export type StandardMemberAttributeColumnBackfillRequestDto = z.infer<
  typeof StandardMemberAttributeColumnBackfillRequestSchema
>;

/**
 * Result of a latest-per-member SMA column backfill (or dry run).
 */
export interface StandardMemberAttributeColumnBackfillResultDto {
  /** False unless the request set `commit: true` and writes ran. */
  committed: boolean;
  column: string;
  snakeCase: string;
  warehouseRowsScanned: number;
  warehouseBatches: number;
  uniqueMembers: number;
  skippedLatestNull: number;
  skippedLatestDelete: number;
  matchedUsers: number;
  missingUsers: number;
  missingSma: number;
  updated: number;
}
